import React from "react";
import { Form } from "react-bootstrap";
import { PermissionWrapper } from "../../PermissionWrapper/PermissionWrapper";

interface EnrolmentTableActionsProps {
  enrolledThrough?: string;
  isActive?: boolean;
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onToggleActive?: () => void;
}

const EnrolmentTableActions: React.FC<EnrolmentTableActionsProps> = ({
  enrolledThrough,
  isActive = false,
  onView,
  onEdit,
  onDelete,
  onToggleActive,
}) => {
  const isOnline = (enrolledThrough ?? "").toLowerCase() === "online";

  return (
    <div className="enrolment-table-actions">
      <button
        type="button"
        className="enrolment-table-action-btn"
        title="View"
        onClick={onView}
      >
        <i className="ri-eye-line" />
      </button>

      <PermissionWrapper
        anyOfPermissions={[
          "academy_management.admin",
          "academy_management.enrollments.manage",
        ]}
        hideWhenDisabled
      >
        <>
          <button
            type="button"
            className="enrolment-table-action-btn"
            title="Edit enrolment"
            onClick={onEdit}
          >
            <i className="ri-edit-line" />
          </button>
          <button
            type="button"
            className={`enrolment-table-action-btn${isOnline ? " text-muted opacity-50" : " text-danger"}`}
            style={isOnline ? { pointerEvents: "none" } : undefined}
            title={isOnline ? "Online enrolments cannot be deleted" : "Delete enrolment"}
            disabled={isOnline}
            onClick={!isOnline ? onDelete : undefined}
          >
            <i className="ri-delete-bin-line" />
          </button>
          <Form.Check
            type="switch"
            className="enrolment-table-status-toggle"
            checked={isActive}
            onChange={onToggleActive}
            title={isActive ? "Mark inactive" : "Mark active"}
            aria-label="Toggle enrolment active status"
          />
        </>
      </PermissionWrapper>
    </div>
  );
};

export default EnrolmentTableActions;
